import { min } from 'date-fns';

import { DatePickerDate } from '../types';

function getEarliestDateSafely(dates?: (DatePickerDate | null | undefined)[]) {
  if (!dates) return null;

  const finalDates: DatePickerDate[] = [];
  dates.forEach((date) => date instanceof Date && finalDates.push(date));

  return finalDates.length > 0 ? min(finalDates) : null;
}

export default getEarliestDateSafely;
